export enum SessionStorageKeysEnum {
  selectedServices = 'selected-services'
}
